<template>
	<div class="subsection"><slot></slot></div>
</template>
<script>
	export default { name: "subsection" }
</script>


// WEBPACK FOOTER //
// src/components/subsection/subsection.vue